'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
require('../../enums/accordion.js');
require('../../enums/alert.js');
require('../../enums/avatar.js');
require('../../enums/breakpoints.js');
var button = require('../../enums/button.js');
require('../../enums/code-editor.js');
require('../../enums/colors.js');
require('../../enums/combobox.js');
require('../../enums/date.js');
require('../../enums/drag-and-drop.js');
require('../../enums/dialog.js');
require('../../enums/divider.js');
require('../../enums/dropdown.js');
require('../../enums/fieldset.js');
require('../../enums/font-icon.js');
require('../../enums/fonts.js');
require('../../enums/headings.js');
require('../../enums/input.js');
require('../../enums/keys.js');
require('../../enums/list.js');
require('../../enums/listbox.js');
var loader = require('../../enums/loader.js');
require('../../enums/margin.js');
require('../../enums/option.js');
require('../../enums/pill.js');
require('../../enums/placements.js');
require('../../enums/popout.js');
require('../../enums/privacy.js');
require('../../enums/radio-group.js');
require('../../enums/status.js');
require('../../enums/switch.js');
require('../../enums/table.js');
require('../../enums/tooltip.js');
require('../../enums/transitions.js');
require('../../enums/widths.js');

/**
 * Get Styled Component loader position flex direction
 * @param options GetLoaderPositionOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getLoaderPosition = (options)=>{
    const { labelPosition , size  } = options;
    const isBottom = labelPosition === loader.LoaderLabelPositions.Bottom;
    const labelMargin = size === loader.LoaderSizes.Large ? '15px' : size === loader.LoaderSizes.Small ? '7px' : '10px';
    const margin = isBottom ? styled.css`
        .bf-loader__label {
          margin-block-start: ${labelMargin};
        }
      ` : styled.css`
        .bf-loader__label {
          margin-inline-start: ${labelMargin};
        }
      `;
    return styled.css`
    flex-direction: ${()=>isBottom ? 'column' : 'row'};
    ${margin}
  `;
};
/**
 * Get Styled Component loader position flex direction
 * @param options GetLoaderSizeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getLoaderSize = (options)=>{
    const { size  } = options;
    switch(size){
        case loader.LoaderSizes.Large:
            {
                return styled.css`
        .bf-loader__label {
          font-size: 22px;
          line-height: 28px;
        }

        .bf-loader__svg {
          height: 60px;
          width: 60px;
        }
      `;
            }
        case loader.LoaderSizes.Small:
            {
                return styled.css`
        .bf-loader__label {
          font-size: 14px;
          line-height: 18px;
        }

        .bf-loader__svg {
          height: 20px;
          width: 20px;
        }
      `;
            }
        default:
            {
                // LoaderSizes.Medium
                return styled.css`
        .bf-loader__label {
          font-size: 18px;
          line-height: 24px;
        }

        .bf-loader__svg {
          height: 40px;
          width: 40px;
        }
      `;
            }
    }
};
/**
 * Get Styled Component loader theme
 * @param options GetLoaderThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getLoaderTheme = (options)=>{
    const { buttonLook , look  } = options;
    const stroke = buttonLook === button.ButtonLooks.Secondary || buttonLook === button.ButtonLooks.Tertiary || buttonLook === button.ButtonLooks.Warning ? styled.css`
          .bf-button__icon--${buttonLook}:hover &,
          .bf-button__standard--${buttonLook}:hover & {
            .bf-loader__svg-circle {
              stroke: ${({ theme  })=>theme.button[buttonLook].textColorHover};
            }
          }

          .bf-button__icon--${buttonLook}:active &,
          .bf-button__standard--${buttonLook}:active & {
            .bf-loader__svg-circle {
              stroke: ${({ theme  })=>theme.button[buttonLook].textColorActive};
            }
          }

          .bf-button__icon--${buttonLook}:focus-visible &,
          .bf-button__standard--${buttonLook}:focus-visible & {
            .bf-loader__svg-circle {
              stroke: ${({ theme  })=>theme.button[buttonLook].textColorFocus};
            }
          }
        ` : '';
    const disabledStroke = buttonLook ? styled.css`
        [aria-disabled='true'] & {
          .bf-loader__svg-circle {
            stroke: ${({ theme  })=>theme.button[buttonLook].textColorDisabled};
          }
        }
      ` : '';
    return styled.css`
    ${stroke}
    ${disabledStroke}

    .bf-loader__label {
      color: ${({ theme  })=>theme.loader[look].textColor};
    }
  `;
};
/**
 * Get Styled Component stroke theme
 * @param options GetLoaderStrokeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getLoaderStroke = (options)=>styled.keyframes`
  0% {
    stroke: ${options.theme.loader[options.look].strokeFromColor};
  }
  100% {
    stroke: ${options.theme.loader[options.look].strokeToColor};
  }
`;
const getLoaderRotate = ()=>styled.keyframes`
  100% {
    transform: rotate(360deg);
  }
`;
const getLoaderStretch = ()=>styled.keyframes`
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dashoffset: -124px;
  }
`;

exports.getLoaderPosition = getLoaderPosition;
exports.getLoaderRotate = getLoaderRotate;
exports.getLoaderSize = getLoaderSize;
exports.getLoaderStretch = getLoaderStretch;
exports.getLoaderStroke = getLoaderStroke;
exports.getLoaderTheme = getLoaderTheme;
//# sourceMappingURL=loader.js.map
